import { render } from "./mvt-radio.vue?vue&type=template&id=1c852482"
import script from "./mvt-radio.js?vue&type=script&lang=js"
export * from "./mvt-radio.js?vue&type=script&lang=js"

import "./mvt-radio.vue?vue&type=style&index=0&id=1c852482&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__